<template>
  <div class="confirm-button">
    <div :class="['button-normal', {'button-login': loginType}, {'button-clean': cleanType}]"
    >{{text}}</div>
  </div>
</template>
<script>
export default {
  name: 'ConfirmButton',
  props: {
    text: {
      type: String,
      default: null
    },
    loginType: {
      type: Boolean,
      default: false
    },
    cleanType: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.confirm-button {

  .button {

    &-normal {
      height: 37px;
      padding: 11px 36px;
      background: #2b5eb3;
      color: #fff;
      border-radius: 18px;
      line-height: 14px;
      text-align: center;

      &:hover {
        background: #598ee5;
        color: #fff;
        cursor: pointer;
      }
    }

    &-login {
      background: #fff;
      color: #2b5eb3;
      border: 1px solid #2b5eb3;

      &:hover {
        background: #2b5eb3;
        color: #fff;
      }
    }

    &-clean {
      background: #fff;
      color: #777d88;
      border: 1px solid #7a859e;

      &:hover {
        color: #b1b8c1;
        background: #fff;
      }
    }
  }

}

@media( max-width: 500px ){

.confirm-button {

  .button {

    &-normal {
      padding: 9px 0px;
      line-height: 19px;

    }
  }
}

}

</style>



// WEBPACK FOOTER //
// src/components/button/ConfirmButton.vue